<template>
  <div :class="['cta', {'--flip': content.imageOnRight}]">
    <Image :source="content.image" class="cta__image"/>
    <div class="cta__content">
      <h2 class="title --uppercase" v-reveal>{{ content.title }}</h2>
      <p class="description" v-reveal>{{ content.description }}</p>
      <div class="cta__buttons-container" v-if="content.buttons?.length ">
        <InternalExternalLink v-for="button in content.buttons" :content="button" :key="`button-${button.flexKey}`" :class="{'--video-link': button.flexLayout === 'video-link-repeatable'}" />
      </div>
    </div>
  </div>
</template>

<script>
import {Image} from '@/components/global'
import {HasContentMixin} from '@/mixins'
import InternalExternalLink from '@/components/small/InternalExternalLink.vue'

export default {
  name: 'CTABlock',
  mixins: [HasContentMixin],
  components: {InternalExternalLink, Image}
}
</script>